import $ from 'jquery';
import notify from '@/migration/notification';

export const handler = {
  updateCurrent: (state: any, props: any) => {
    return async (current: any) => {
      const {actions, bans} = props;
      const {setDisabled} = state;

      setDisabled(true);

      actions.bans.updateCurrent(current);
      await actions.bans.getPagination(
        current,
        bans.searchWords,
        bans.sortState
      );
      // ページネーション更新時テーブル内スクロール位置をトップにする
      $('.rt-tbody').scrollTop(0);

      setDisabled(false);
    };
  },
  updateSortState: (state: any, props: any) => async (sortState: any) => {
    props.actions.bans.updateSortState(sortState);

    state.setLoading(true);

    await props.actions.bans.getPagination(
      1,
      props.bans.searchWords,
      sortState
    );

    state.setLoading(false);
  },
  addSearchWord: (state: any, props: any) => async (value: any) => {
    if (value) {
      try {
        props.actions.bans.addSearchWord(value);

        const targetWords = [...props.bans.searchWords, value];
        state.setLoading(true);
        props.reset();

        await props.actions.bans.getPagination(
          1,
          targetWords,
          props.bans.sortState
        );

        // 検索時スクロール位置をトップにする
        $('.rt-tbody').scrollTop(0);

        state.setLoading(false);
      } catch (error) {
        notify('検索に失敗しました。リロードしてください。', 'error');
        state.setLoading(false);
      }
    }
  },
  removeSearchWord: (state: any, props: any) => async (index: any) => {
    try {
      props.actions.bans.removeSearchWord(index);

      const targetWords = props.bans.searchWords.filter(
        (word: any, i: number) => {
          return index !== i;
        }
      );
      state.setLoading(true);

      await props.actions.bans.getPagination(
        1,
        targetWords,
        props.bans.sortState
      );

      state.setLoading(false);
    } catch (error) {
      notify('検索に失敗しました。リロードしてください。', 'error');
      state.setLoading(false);
    }
  },
};
